/* eslint-disable max-len */
import { serviceName } from '../resources/serviceConstants';
import {
// endpoint for timeline change requests
} from '../resources/endPoint';

const TIMELINE_BASE = '/v1/timeline-change-request';

const buildProjectRequest = (url, method = 'get', payload) => ({
  url,
  method,
  headers: { 'Content-Type': 'application/json' },
  authRequired: false,
  csrfToken: true,
  ...(payload !== undefined ? { payload } : {}),
  service: serviceName.PROJECT_MS,
  timeout: 180000,
});

/**
 * Consolidated Timeline Change Request API
 *
 * Main endpoint for all timeline change request operations (POST).
 *
 * @param {Object} payload - Request payload
 *
 * For FETCHING timeline requests:
 * - Include: filter[], pagination {limit, page}, userInfo
 * - Optional: projectId, projectName for scoped filtering
 *
 * For CREATING new timeline requests:
 * - Include: projectId, requestedFieldValue, newDate, reasonForChange
 * - Optional: approvalLink (for Baseline Start/End Date)
 * - Include: userInfo for authorization
 *
 * @returns {Object} Request configuration for axios
 */
export const getTimelineRequests = (payload) => buildProjectRequest(
  TIMELINE_BASE,
  'post',
  payload,
);

/**
 * Create a new timeline change request
 * Uses the consolidated POST / endpoint with create-specific payload
 *
 * @param {Object} payload - Timeline request data
 * @returns {Object} Request configuration for axios
 */
export const createTimelineRequest = (payload) => buildProjectRequest(
  TIMELINE_BASE,
  'post',
  payload,
);

export const updateTimelineRequest = (id, payload) => buildProjectRequest(
  `${TIMELINE_BASE}/${id}`,
  'put',
  payload,
);

export const updateTimelineRequestStatus = (payload) => buildProjectRequest(
  `${TIMELINE_BASE}/status`,
  'put',
  payload,
);

export const deleteTimelineRequest = (id) => buildProjectRequest(
  `${TIMELINE_BASE}/${id}`,
  'delete',
);

